module.exports = __webpack_public_path__ + "img/wolt.00c6f6c1.svg";